import { render, staticRenderFns } from "./RichTextEditorHugeRTE.vue?vue&type=template&id=206786ec&"
import script from "./RichTextEditorHugeRTE.vue?vue&type=script&lang=ts&"
export * from "./RichTextEditorHugeRTE.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports